var _defs, _path, _circle, _path2, _circle2, _path3, _circle3, _rect, _circle4, _rect2, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphic2_right",
    "data-name": "graphic2 right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 333,
    height: 575,
    viewBox: "0 0 333 575",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .login-bg-right-cls-1 {\n        fill: #d4c527;\n      }\n\n      .login-bg-right-cls-1, .login-bg-right-cls-3, .login-bg-right-cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .login-bg-right-cls-1, .login-bg-right-cls-3, .login-bg-right-cls-5 {\n        opacity: 0.5;\n      }\n\n      .login-bg-right-cls-2, .login-bg-right-cls-3 {\n        fill: #ee162d;\n      }\n\n      .login-bg-right-cls-4, .login-bg-right-cls-5, .login-bg-right-cls-6 {\n        fill: #424143;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_4",
    "data-name": "Rectangle 2 copy 4",
    className: "login-bg-right-cls-1",
    d: "M4409,2142a40,40,0,0,0-40,40v71a40,40,0,0,0,80,0V2148h10v105a50,50,0,0,1-100,0v-71a50.005,50.005,0,0,1,50-50h171v10H4409Zm40-113.83h10V2130h-10V2028.17Z",
    transform: "translate(-4359 -2029)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_4",
    "data-name": "Ellipse 1 copy 4",
    className: "login-bg-right-cls-2",
    cx: 221,
    cy: 108,
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_9",
    "data-name": "Rectangle 2 copy 9",
    className: "login-bg-right-cls-3",
    d: "M4510,2569a25,25,0,0,0,25,25h175v10H4535a35,35,0,0,1,0-70h56v10h-56A25,25,0,0,0,4510,2569Z",
    transform: "translate(-4359 -2029)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_11",
    "data-name": "Ellipse 1 copy 11",
    className: "login-bg-right-cls-2",
    cx: 231,
    cy: 510,
    r: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7",
    "data-name": "Rectangle 2 copy 7",
    className: "login-bg-right-cls-4",
    d: "M4710,2390H4478a25,25,0,0,0,0,50h66v10h-66a35,35,0,0,1,0-70h232v10Z",
    transform: "translate(-4359 -2029)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_8",
    "data-name": "Ellipse 1 copy 8",
    className: "login-bg-right-cls-2",
    cx: 185,
    cy: 416,
    r: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy_4",
    "data-name": "Rectangle 3 copy 4",
    className: "login-bg-right-cls-5",
    x: 245,
    y: 192,
    width: 106,
    height: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_13",
    "data-name": "Ellipse 1 copy 13",
    className: "login-bg-right-cls-2",
    cx: 245,
    cy: 197,
    r: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy",
    "data-name": "Rectangle 3 copy",
    className: "login-bg-right-cls-6",
    x: 165,
    y: 291,
    width: 186,
    height: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_7",
    "data-name": "Ellipse 1 copy 7",
    className: "login-bg-right-cls-2",
    cx: 165,
    cy: 296,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicRight);
export default __webpack_public_path__ + "static/media/graphic-right.4c54914b827228dbc4bc328548f9bdd1.svg";
export { ForwardRef as ReactComponent };